var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getBadgeDetailsFunctionDef } from '../../../../backend/features/badges/shared';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import useSWR from 'swr';
export const badgeDetailsFetchKey = 'badgeDetails';
export const useStorageGetBadgeDetails = ({ badgeId, }) => {
    const getBadgeDetailsPlatformFn = useTypedPlatformFunction(getBadgeDetailsFunctionDef);
    const { data, isLoading, mutate } = useSWR(badgeId ? [badgeDetailsFetchKey, badgeId] : null, ([, badgeId]) => getBadgeDetailsPlatformFn({ id: badgeId }).catch(handleErrorSnackbar), { revalidateOnFocus: false, revalidateOnReconnect: false });
    const fetchBadgeDetails = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        isLoading,
        data,
        fetchBadgeDetails,
    };
};
